const getCSRFToken = () => {
  const metaTag = document.querySelector('meta[name="csrf-token"]');
  if (metaTag) return metaTag.getAttribute("content");
  const csrfCookie = document.cookie
    .split("; ")
    .find(
      (row) => row.startsWith("csrftoken=") || row.startsWith("csrf_token=")
    );
  if (csrfCookie) return csrfCookie.split("=")[1];
  return (
    sessionStorage.getItem("csrf_token") ||
    localStorage.getItem("csrf_token") ||
    sessionStorage.getItem("csrftoken") ||
    localStorage.getItem("csrftoken")
  );
};

// Purpose of visit options
const purposeOptions = [
  { key: "study", value: "Study", text: "📚 Study", icon: "book" },
  { key: "research", value: "Research", text: "🔬 Research", icon: "search" },
  { key: "reading", value: "Reading", text: "📖 Reading", icon: "bookmark" },
  {
    key: "group_study",
    value: "Group Study",
    text: "👥 Group Study",
    icon: "users",
  },
  {
    key: "computer_use",
    value: "Computer Use",
    text: "💻 Computer Use",
    icon: "computer",
  },
  { key: "printing", value: "Printing", text: "🖨️ Printing", icon: "print" },
  { key: "meeting", value: "Meeting", text: "🤝 Meeting", icon: "handshake" },
  {
    key: "event",
    value: "Event/Activity",
    text: "🎯 Event/Activity",
    icon: "calendar",
  },
  {
    key: "borrowing",
    value: "Book Borrowing",
    text: "📚 Book Borrowing",
    icon: "book",
  },
  {
    key: "internet",
    value: "Internet Access",
    text: "🌐 Internet Access",
    icon: "wifi",
  },
  {
    key: "consultation",
    value: "Consultation",
    text: "💬 Consultation",
    icon: "chat",
  },
  {
    key: "recreational activity",
    value: "Recreational Activity",
    text: "🎲 Recreational Activity",
    icon: "cogs",
  },
];
// Styles
const fullScreenStyle = {
  minHeight: "100vh",
  width: "100vw",
  backgroundImage: "url('/images/library-bldg.jpg')",
  backgroundAttachment: "fixed",
  backgroundSize: "cover",
  backgroundPosition: "center",
  position: "fixed",
  top: 0,
  left: 0,
  overflow: "auto",
  zIndex: 1000,
};

const containerStyle = {
  maxWidth: "1200px",
  minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "2rem",
};

const segmentStyle = {
  background: "rgba(255, 255, 255, 0.432)",
  boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)",
  backdropFilter: "blur(20px)",
  WebkitBackdropFilter: "blur(20px)",
  border: "1px solid rgba(255, 255, 255, 0.3)",
  borderRadius: "20px",
  padding: "3rem",
  color: "#000",
};

const welcomeHeaderStyle = {
  fontSize: "2.5rem",
  color: "#225745",
  marginBottom: "1rem",
  fontWeight: "bold",
};

const subHeaderStyle = {
  fontSize: "1.2rem",
  color: "#000000",
  marginTop: "1rem",
};

const inputStyle = {
  borderRadius: "25px",
  fontSize: "1.2rem",
  textAlign: "center",
};

const buttonStyle = {
  borderRadius: "15px",
  fontSize: "1.2rem",
  fontWeight: "bold",
};

const dropdownStyle = {
  borderRadius: "10px",
  fontSize: "1rem",
  width: "100%",
};

export {
  purposeOptions,
  getCSRFToken,
  fullScreenStyle,
  containerStyle,
  segmentStyle,
  welcomeHeaderStyle,
  subHeaderStyle,
  inputStyle,
  buttonStyle,
  dropdownStyle,
};
